import { t } from 'i18next'

import { VideoCacheRecord } from '../../models3/VideoCacheRecord'
import { getVideoDuration } from '../../models3/VideoDuration'
import { fmt } from '../utils/Fmt'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const log = require('debug')('sltt:VideoUploader')

const intest = localStorage.getItem('intest') === 'true'

export interface RecordingDoneParams {
    err: any
    blobsCount: number
    url: string
    duration: number
    mimeType: string
}

export class VideoUploader {
    // @observable public blobs: Array<Blob> = []
    // @observable public blobsSent = 0
    // private pushingBlob = false

    private blobs: Blob[] = []

    constructor(
        public path: string,
        public onRecordingDone: ({ err, blobsCount, url, duration, mimeType }: Partial<RecordingDoneParams>) => void
    ) {}

    async pushVideoBlob(blob: Blob, lastBlob: boolean) {
        log('pushVideoBlob', fmt({ size: blob.size, lastBlob }))

        this.blobs.push(blob)

        if (lastBlob) {
            await this.finishUpload()
        }
    }

    private async finishUpload() {
        const { path, blobs } = this
        const _id = `${this.path}-${blobs.length}`
        log('finishUpload', fmt({ _id }))
        const vcr = new VideoCacheRecord({ _id })

        let mimeType = ''
        let blobSize = 0
        for (const blob of blobs) {
            await vcr.addBlob(blob)
            mimeType = blob.type
            blobSize += blob.size
        }

        if (!mimeType || !blobSize) {
            this.onRecordingDone({ err: t('videoUploaderInvalidBlobError') })
            return
        }

        await vcr.saveToDB()

        const blob = new Blob(blobs, { type: mimeType })
        const duration = intest ? 1.5 : await getVideoDuration(blob)
        log('finishUpload', fmt({ duration }))

        // This will add the resulting item to the model
        this.onRecordingDone({ blobsCount: blobs.length, url: path, duration, mimeType })
    }
}
